import React from 'react';
import { Box, Stack } from '@chakra-ui/react';
import { useGetSignUpServiceEmail, useSignUpEmail, useTimer } from 'hooks';
import { useTranslation } from 'localization';

import {
  AuthSuggestion,
  DesktopAuthHeader,
  SERVICE_CARD_BORDER_RADIUS,
} from 'components';

import { Form } from './components';

const SignUp: React.FC = () => {
  const { t } = useTranslation('component.auth.signUp');
  const { counter, setCounter } = useTimer(0);

  const { mutateAsync: submit, isPending: isSubmitting } = useSignUpEmail();

  const externalUserData = useGetSignUpServiceEmail();

  return (
    <Stack w="100%" align="stretch" gap={{ base: 6, md: 8 }}>
      <DesktopAuthHeader
        title={t('signUpToMagix')}
        subTitle={t('openAccount')}
        titleAlign="center"
      />
      <Box
        bg="dark"
        borderWidth="1px"
        borderColor="rgba(255,255,255,0.08)"
        borderRadius={SERVICE_CARD_BORDER_RADIUS}
        px={{ base: 5, md: 7 }}
        py={{ base: 6, md: 8 }}
        w="100%"
      >
        <Form
          isSubmitting={isSubmitting}
          onButton={(data) =>
            submit(data).then(() => {
              setCounter(120);
            })
          }
          isDisableForm={counter !== 0}
          counter={counter}
          defaultEmail={externalUserData.client_email}
        />
      </Box>
      <AuthSuggestion include={['sign-in']} />
    </Stack>
  );
};

export default SignUp;
